module.exports = __webpack_public_path__ + "img/top.17340467.png";